(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[987],{

/***/ 36223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/watch/[videoId]",
      function () {
        return __webpack_require__(98551);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _videoId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/datasets/webinars.js
var webinars = __webpack_require__(85548);
// EXTERNAL MODULE: ./src/landingPage/views/components/FormComponent.jsx + 1 modules
var FormComponent = __webpack_require__(69519);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/views/Webinars/components/WebinarVideoForm.jsx




var WebinarVideoForm = function(param) {
    var setFlagPresent = param.setFlagPresent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "webinar_video_form-background",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiTv */.CSS, {
                className: "webinar_video_form-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "webinar_video_form-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "webinar_video_form-header",
                        children: webinars/* webinar.form.header */.L.form.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponent/* StandardFormComponent */.s, {
                        data: webinars/* webinar.form */.L.form,
                        setFlagPresent: setFlagPresent,
                        pipedriveType: "View Webinar",
                        formName: "Webinar video",
                        gaName: "Webinar Video",
                        isConsent: false
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 14 modules
var format = __webpack_require__(4758);
;// CONCATENATED MODULE: ./src/landingPage/views/Webinars/components/WebinarsPlayer.jsx




var WebinarsPlayer = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(), flagPresent = ref[0], setFlagPresent = ref[1];
    (0,react.useEffect)(function() {
        setFlagPresent(localStorage.getItem("video_form_filled"));
    }, []);
    /* eslint-disable jsx-a11y/media-has-caption */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            flagPresent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                className: "webinar_player",
                src: data === null || data === void 0 ? void 0 : data.video_actual,
                controls: true,
                children: [
                    "Sorry, your browser doesn't support HTML5 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "video"
                    }),
                    ", but you can download this video from the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: data === null || data === void 0 ? void 0 : data.video_actual,
                        target: "_blank",
                        rel: "noreferrer",
                        children: data === null || data === void 0 ? void 0 : data.title
                    }),
                    "."
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarVideoForm, {
                setFlagPresent: setFlagPresent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "webinar_player-title",
                children: data === null || data === void 0 ? void 0 : data.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "webinar_player-date",
                children: (data === null || data === void 0 ? void 0 : data.date) && (0,format/* default */.Z)(new Date(data === null || data === void 0 ? void 0 : data.date), "LLLL dd, yyyy")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/landingPage/views/components/ui/BottomCTA.jsx
var BottomCTA = __webpack_require__(96096);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/slugify.js
var slugify = __webpack_require__(28490);
;// CONCATENATED MODULE: ./src/landingPage/views/Webinars/WebinarsVideo.jsx







var WebinarsVideo = function(param) {
    var butterData = param.butterData, videoData = param.videoData, webinarDataset = param.webinarDataset;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var generatedPath = "".concat(linksConstants/* linksConstants.WEBINARS_VIDEO_SLUGIFIED.split */.s.WEBINARS_VIDEO_SLUGIFIED.split("/:")[0], "/").concat(videoData.video_actual.split("/").reverse()[0], "--").concat((0,slugify/* slugify */.l)(videoData.title));
        router.asPath !== generatedPath && router.replace(generatedPath, undefined, {
            shallow: true
        });
    }, [
        videoData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "webinars_video",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "webinars_video-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "section-layout",
                    children: butterData.webinars && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarsPlayer, {
                            data: videoData
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCTA/* BottomCTA */.j, {
                data: webinarDataset.bottomCTA,
                unskewed: true
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
;// CONCATENATED MODULE: ./pages/webinars/watch/[videoId].jsx




var WebinarVideoPage = function(param) {
    var butterData = param.butterData, videoData = param.videoData, resolvedUrl = param.resolvedUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: resolvedUrl,
                title: "".concat((videoData === null || videoData === void 0 ? void 0 : videoData.title) && "".concat(videoData === null || videoData === void 0 ? void 0 : videoData.title, " - "), "Webinars"),
                description: "Provide your name and email to gain access to this webinar."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarsVideo, {
                butterData: butterData,
                videoData: videoData,
                webinarDataset: webinars/* webinar */.L
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _videoId_ = (WebinarVideoPage);


/***/ }),

/***/ 85548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ webinar; }
/* harmony export */ });
var webinar = {
    bottomCTA: {
        head: "External data should be easy to discover and deploy"
    },
    button: "Learn More",
    button_link: "",
    form: {
        header: "Please provide your name and email address to gain access to this webinar",
        fields: [
            {
                label: "Full name",
                id: "full_name",
                type: "text",
                component: "input",
                required: true
            },
            {
                label: "Email",
                id: "email",
                type: "email",
                component: "input",
                required: true
            }, 
        ]
    }
};


/***/ }),

/***/ 69519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ StandardFormComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/Button.jsx
var Button = __webpack_require__(88749);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(17609);
// EXTERNAL MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx + 7 modules
var StandardField = __webpack_require__(24606);
// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/landingPage/datasets/formComponent.js
var formComponent = __webpack_require__(86713);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__(84557);
;// CONCATENATED MODULE: ./src/api/publicApi.js



var publicApi = {
    sendRegistrant: function sendRegistrant(webinarId, registrant) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api/* demystConsoleApi.post */.Es.post("/public/webinars/".concat(webinarId, "/registrants"), {
                            registrant: registrant
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }
};

// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/landingPage/views/components/FormComponent.jsx















var StandardFormComponent = function(param) {
    var data = param.data, changeModalOpen = param.changeModalOpen, changeErrorModalOpen = param.changeErrorModalOpen, pipedriveType = param.pipedriveType, formName = param.formName, gaName = param.gaName, caseStudy = param.caseStudy, _resetValuesAfterwards = param.resetValuesAfterwards, resetValuesAfterwards = _resetValuesAfterwards === void 0 ? false : _resetValuesAfterwards, _isConsent = param.isConsent, isConsent = _isConsent === void 0 ? true : _isConsent, customButtonText = param.customButtonText, _isButtonInverted = param.isButtonInverted, isButtonInverted = _isButtonInverted === void 0 ? false : _isButtonInverted, setFlagPresent = param.setFlagPresent, webinarIdZoom = param.webinarIdZoom, setModalOpen = param.setModalOpen;
    var ref = (0,react.useState)({}), formData = ref[0], changeFormData = ref[1];
    var ref1 = (0,react.useState)({}), errors = ref1[0], changeErrors = ref1[1];
    var ref2 = (0,react.useState)(false), consent = ref2[0], changeConsent = ref2[1];
    var ref3 = (0,react.useState)(false), sending = ref3[0], changeSending = ref3[1];
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath;
    var ref4 = (0,react.useState)(null), linkedInCookie = ref4[0], setLinkedInCookie = ref4[1];
    (0,react.useEffect)(function() {
        setLinkedInCookie(localStorage.getItem("li_fat_id"));
    }, []);
    var isFirstLastNamePresent = function(fields) {
        var isFirstName = typeof fields.first_name !== "undefined";
        var isLastName = typeof fields.last_name !== "undefined";
        if (!isFirstName && !isLastName) return false;
        return true;
    };
    var resetForm = function() {
        var newFormData = {};
        data.fields.forEach(function(field) {
            if (field.component !== "standard-multielement") {
                newFormData[field.id] = "";
            } else {
                field.fields.forEach(function(subfield) {
                    newFormData[subfield.id] = "";
                });
            }
        });
        if (isFirstLastNamePresent(newFormData) === true) newFormData.full_name = "".concat(newFormData.first_name, " ").concat(newFormData.last_name);
        changeFormData(newFormData);
        changeConsent(false);
    };
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        if (data.id === "first_name" || data.id === "last_name") {
            newFormData.full_name = "".concat(newFormData.first_name, " ").concat(newFormData.last_name);
        }
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = (0,formAttribution/* formAttribution */.e)(pipedriveType);
        if (formName !== "Catalog Bottom") {
            preparedData = (0,_object_spread/* default */.Z)({}, preparedData, formData);
        } else {
            preparedData.full_name = formData.full_name_bottom;
            preparedData.email = formData.email_bottom;
        }
        return preparedData;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend, setUserTracking, registrantPayload, webinarId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!(!sending && (0,form_functions/* validate */.G)({
                            formData: formData,
                            data: data,
                            changeErrors: changeErrors,
                            consent: isConsent ? consent : true
                        }) === true)) {
                            _ctx.next = 27;
                            break;
                        }
                        changeSending(true);
                        dataToSend = {
                            type: formName,
                            formValues: preparedData()
                        };
                        linkedInCookie && (0,userTracking.sendLinkedInConversion)();
                        setUserTracking = function() {
                            var formattedUserToTrack = {
                                user: {
                                    email: formData.email,
                                    name: formData.full_name
                                }
                            };
                            if (formData.company_name || formData.company_name === "") formattedUserToTrack.organization = {
                                name: formData.company_name || ""
                            };
                            if (formName === "Catalog Bottom") {
                                formattedUserToTrack.user = {
                                    email: formData.email_bottom,
                                    name: formData.full_name_bottom
                                };
                            }
                            var gaEmail = formName === "Catalog Bottom" ? formData.email_bottom : formData.email;
                            var urlPath = pathname;
                            if (formName === "Solutions whitepaper") urlPath = "/solution/whitepaper";
                            if (formName === "Webinar video") urlPath = "/webinar_video";
                            (0,userTracking/* sendGaEvent */.k8)({
                                action: "Form Submission",
                                category: "Lead",
                                label: "Submit - ".concat(gaName ? gaName : formName, " Form - ").concat(urlPath)
                            }, gaEmail);
                        };
                        _ctx.prev = 6;
                        if (!(formName === "Webinar registration")) {
                            _ctx.next = 12;
                            break;
                        }
                        registrantPayload = {
                            email: formData.email,
                            full_name: formData.full_name,
                            company_name: formData.company_name || "",
                            job_title: formData.job_title || "",
                            message: formData.message || ""
                        };
                        webinarId = webinarIdZoom.replaceAll(" ", "");
                        _ctx.next = 12;
                        return publicApi.sendRegistrant(webinarId, registrantPayload);
                    case 12:
                        dataToSend.formValues.case_study = caseStudy;
                        _ctx.next = 15;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 15:
                        if (formName === "Webinar video") {
                            setFlagPresent && setFlagPresent(true);
                            localStorage.setItem("video_form_filled", true);
                        }
                        setUserTracking();
                        resetValuesAfterwards && resetForm();
                        changeModalOpen && changeModalOpen(true);
                        setModalOpen && setModalOpen(true);
                        changeSending(false);
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](6);
                        changeErrorModalOpen && changeErrorModalOpen(true);
                        changeSending(false);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    23
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        resetForm();
    }, []);
    return Object.keys(formData).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            noValidate: true,
            title: formName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                    fields: data.fields,
                    formData: formData,
                    changeData: changeData,
                    errors: errors
                }),
                isConsent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: "consent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsCheckbox/* TermsCheckbox */.H, {
                            text: formComponent/* formComponent.form.consent */.j.form.consent,
                            checked: consent,
                            onChange: changeConsent,
                            error: errors.consent
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: sending,
                        variant: isButtonInverted ? "inverted" : "primary",
                        demystIcon: true,
                        children: customButtonText || formComponent/* formComponent.button_text */.j.button_text
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ }),

/***/ 17609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TermsCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var TermsCheckbox = function(param) {
    var checked = param.checked, onChange = param.onChange, text = param.text, error = param.error, _classNameForText = param.classNameForText, classNameForText = _classNameForText === void 0 ? "terms_checkbox-text" : _classNameForText, _classNameMain = param.classNameMain, classNameMain = _classNameMain === void 0 ? "terms_checkbox-main" : _classNameMain, _classNameContainer = param.classNameContainer, classNameContainer = _classNameContainer === void 0 ? "terms_checkbox-container" : _classNameContainer, _classNameError = param.classNameError, classNameError = _classNameError === void 0 ? "terms_checkbox-error" : _classNameError;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classNameMain,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "terms_checkbox-label",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classNameContainer,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "checkbox",
                                value: text,
                                checked: checked,
                                onChange: function() {
                                    return onChange(!checked);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "terms_checkbox-box"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: classNameForText,
                        children: [
                            text.beginning,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link1_url,
                                    children: text.link1_text
                                })
                            }),
                            text.separator,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "demyst-blue",
                                    href: text.link2_url,
                                    children: text.link2_text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classNameError,
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 96096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ BottomCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_MainCtaButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11723);


var BottomCTA = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "bottom_cta-background",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "bottom_cta-text",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "bottom_cta-head",
                        children: data.head
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "bottom_cta-buttons",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainCtaButton__WEBPACK_IMPORTED_MODULE_1__/* .MainCtaButton */ .T, {
                            section: "Discover-and-Deploy"
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formAttribution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var formAttribution = function(body) {
    var landingPage = localStorage.getItem("landing_page");
    var landingPageDatetime = localStorage.getItem("landing_page_datetime");
    var landingPageFullUrl = localStorage.getItem("landing_page_full_url");
    var currentPagePath = localStorage.getItem("current_page_path");
    var currentPagePathDatetime = localStorage.getItem("current_page_path_datetime");
    var prevPagePath = localStorage.getItem("prev_page_path");
    var prevPagePathDatetime = localStorage.getItem("prev_page_path_datetime");
    var pageFlow = JSON.parse(localStorage.getItem("page_flow"));
    var sessionPageFlow = JSON.parse(sessionStorage.getItem("session_page_flow"));
    var gaAdCookie = localStorage.getItem("gaAd");
    var gaAdCookieUpdated = localStorage.getItem("gaAd_updated");
    var gaAdCookieCreated = localStorage.getItem("gaAd_created");
    var isProductKickingAss = (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/external-data/")) || (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/third-party-data/"));
    var googleAdsGclid = localStorage.getItem("gclid");
    var googleAdsGclidCreated = localStorage.getItem("gclid_created");
    var googleAdsGclidUpdated = localStorage.getItem("gclid_updated");
    var linkedInCookie = localStorage.getItem("li_fat_id");
    var linkedInCookieCreated = localStorage.getItem("li_fat_id_created");
    var linkedInCookieUpdated = localStorage.getItem("li_fat_id_updated");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmMediumCreated = localStorage.getItem("utm_medium_created");
    var utmMediumUpdated = localStorage.getItem("utm_medium_updated");
    var utmSource = localStorage.getItem("utm_source");
    var utmSourceCreated = localStorage.getItem("utm_source_created");
    var utmSourceUpdated = localStorage.getItem("utm_source_updated");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var utmCampaignCreated = localStorage.getItem("utm_campaign_created");
    var utmCampaignUpdated = localStorage.getItem("utm_campaign_updated");
    var utmContent = localStorage.getItem("utm_content");
    var utmContentCreated = localStorage.getItem("utm_content_created");
    var utmContentUpdated = localStorage.getItem("utm_content_updated");
    var utmTerm = localStorage.getItem("utm_term");
    var utmTermCreated = localStorage.getItem("utm_term_created");
    var utmTermUpdated = localStorage.getItem("utm_term_updated");
    var marketingSource = linkedInCookie ? "linkedin" : googleAdsGclid ? "google(cpc)" : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        body: body
    }, landingPage && {
        landing_page: landingPage
    }, landingPageFullUrl && {
        landing_page_full_url: landingPageFullUrl
    }, landingPageDatetime && {
        landing_page_datetime: landingPageDatetime
    }, currentPagePath && {
        current_page_path: currentPagePath
    }, currentPagePathDatetime && {
        current_page_path_datetime: currentPagePathDatetime
    }, prevPagePath && {
        prev_page_path: prevPagePath
    }, prevPagePathDatetime && {
        prev_page_path_datetime: prevPagePathDatetime
    }, sessionPageFlow && {
        session_page_flow: sessionPageFlow
    }, pageFlow && {
        macro_page_flow: pageFlow
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmMediumCreated && {
        utm_medium_created: utmMediumCreated
    }, utmMediumUpdated && {
        utm_medium_updated: utmMediumUpdated
    }, utmSource && {
        utm_source: utmSource
    }, utmSourceCreated && {
        utm_source_created: utmSourceCreated
    }, utmSourceUpdated && {
        utm_source_updated: utmSourceUpdated
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmCampaignCreated && {
        utm_campaign_created: utmCampaignCreated
    }, utmCampaignUpdated && {
        utm_campaign_updated: utmCampaignUpdated
    }, utmContent && {
        utm_content: utmContent
    }, utmContentCreated && {
        utm_content_created: utmContentCreated
    }, utmContentUpdated && {
        utm_content_updated: utmContentUpdated
    }, utmTerm && {
        utm_term: utmTerm
    }, utmTermCreated && {
        utm_term_created: utmTermCreated
    }, utmTermUpdated && {
        utm_term_updated: utmTermUpdated
    }, marketingSource && {
        marketing_source: marketingSource
    }, gaAdCookie && {
        gaAd: gaAdCookie
    }, gaAdCookieCreated && {
        gaAd_created: gaAdCookieCreated
    }, gaAdCookieUpdated && {
        gaAd_updated: gaAdCookieUpdated
    }, isProductKickingAss && {
        pikYa: isProductKickingAss
    }, googleAdsGclid && {
        gclid: googleAdsGclid
    }, googleAdsGclidCreated && {
        gclid_created: googleAdsGclidCreated
    }, googleAdsGclidUpdated && {
        gclid_updated: googleAdsGclidUpdated
    }, linkedInCookie && {
        li_fat_id: linkedInCookie
    }, linkedInCookieCreated && {
        li_fat_id_created: linkedInCookieCreated
    }, linkedInCookieUpdated && {
        li_fat_id_updated: linkedInCookieUpdated
    }, document.referrer && {
        referrer: document.referrer
    });
};


/***/ }),

/***/ 28490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
var slugify = function(string) {
    if (!string) return null;
    var stripAccents = function(string) {
        var accents = "\xc0\xc1\xc2\xc3\xc4\xc5Ą\xe0\xe1\xe2\xe3\xe4\xe5ą\xd2\xd3\xd4\xd5\xd5\xd6\xd8\xf2\xf3\xf4\xf5\xf6\xf8\xc8\xc9\xca\xcbĘ\xe8\xe9\xea\xeb\xf0ę\xc7Ć\xe7ć\xd0\xcc\xcd\xce\xcf\xec\xed\xee\xef\xd9\xda\xdb\xdc\xf9\xfa\xfb\xfc\xd1\xf1ŠŚšśŸ\xff\xfdŽŹŻžźżŁłŃń\xe0\xe1\xe3ảạăằắẳẵặ\xe2ầấẩẫậ\xe8\xe9ẻẽẹ\xeaềếểễệđ\xf9\xfaủũụưừứửữự\xf2\xf3ỏ\xf5ọ\xf4ồốổỗộơờớởỡợ\xec\xedỉĩị\xe4\xeb\xef\xee\xf6\xfc\xfb\xf1\xe7\xfdỳỹỵỷ";
        var fixes = "AAAAAAAaaaaaaaOOOOOOOooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNnSSssYyyZZZzzzLlNnaaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
        var split = accents.split("").join("|");
        var regex = new RegExp("(".concat(split, ")"), "g");
        var replacement = function(string) {
            return fixes[accents.indexOf(string)] || "";
        };
        return string.replace(regex, replacement);
    };
    var getSafeRegexString = function(string) {
        return string.split("").map(function(char) {
            return "\\".concat(char);
        }).join("");
    };
    var delimiter = "-";
    var safeDelimiter = getSafeRegexString(delimiter);
    var nonValidRegex = new RegExp("[^a-z0-9".concat(safeDelimiter, "]+"), "g");
    var multipleDelimitersRegex = new RegExp("".concat(safeDelimiter, "+"), "g");
    var leadingDelimiterRegex = new RegExp("^".concat(safeDelimiter), "g");
    var trailingDelimiterRegex = new RegExp("".concat(safeDelimiter, "$"), "g");
    var newString = stripAccents(string).trim().toLowerCase().replace(nonValidRegex, delimiter).replace(multipleDelimitersRegex, delimiter).replace(leadingDelimiterRegex, "").replace(trailingDelimiterRegex, "");
    return newString;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2777,8540,9774,2888,179], function() { return __webpack_exec__(36223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);